import styled from 'styled-components';
import React from 'react';

const MaxLengthCounter = styled('span')`
  font-size: 11px;
  color: #a8abae;
`;

const TextInputLimitCounter = ({ currentLength, maxLength }) => {
  return (
    <MaxLengthCounter>
      {currentLength}/{maxLength}
    </MaxLengthCounter>
  );
};

export default TextInputLimitCounter;
